import {
  SHOW_TURNTABLE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_MODE,
  CHANGE_KEY_TEXT,
  SET_TURNTABLE_SIZE,
  SAVE_LOCAL_CHOICES_LIST,
  SET_HISTORY,
  SET_TITLE_OBJ,
  SET_WEIGHT_ON,
  SET_SAVED_LISTS,
  RESET_INITIAL_STATE,
  REPLACE_STATE,
  SET_HEADLINE_ON,
  SET_COLOR_ON,
  SET_INPUT_SHOW_MODE,
  SET_INPUT_EDIT_MODE,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
  SET_CHOICE_HD_IMAGES,
  SET_AI_INPUT_LOGIN,
  SET_AI_INPUT_OPENED,
  SET_AI_INPUT_GROUPS,
} from './constants'

import { setStartRotate } from '../turntable/actions'
import { setCurrentFileKey, setDataStatus } from '../common/actions'
import {
  duplicateHDImage,
  deleteHDImage,
  revokeUnusedBlobURL,
} from '../../utils/HDImageUtil'

export const showTurntable = turntable => ({
  type: SHOW_TURNTABLE,
  payload: {
    turntable,
  },
})

export const setTurntableSize = size => ({
  type: SET_TURNTABLE_SIZE,
  payload: {
    size,
  },
})

export const setResultSelected = (
  result,
  resultIndex = -1,
  resultPieColor = null,
) => ({
  type: SET_RESULT_SELECTED,
  payload: {
    result,
    resultIndex,
    resultPieColor,
  },
})

export const setChoices =
  (choices, resetAngle = true) =>
  (dispatch, getState) => {
    if (resetAngle) {
      const state = getState()
      const startAngle = state.settings.spinBehavior.randomStart
        ? 2 * Math.PI * Math.random()
        : 0
      dispatch(setStartRotate(startAngle))
    }
    dispatch({
      type: SET_CHOICES,
      payload: {
        choices,
      },
    })
    dispatch(setDataStatus('Modified', 'Inputs'))
  }

// export const setChoicesAction = choices => ({
//   type: SET_CHOICES,
//   payload: {
//     choices,
//   },
// })

export const setMode = mode => ({
  type: SET_MODE,
  payload: {
    mode,
  },
})

export const changeKeyText = () => ({
  type: CHANGE_KEY_TEXT,
})

export const saveLocalChoicesList = data => {
  return {
    type: SAVE_LOCAL_CHOICES_LIST,
    payload: {
      data,
    },
  }
}

export const setLoadSaveData =
  (id, choices = null, title = null, keyText = false) =>
  (dispatch, getState) => {
    dispatch(setCurrentFileKey(id))
    // dispatch(setListName(name))
    if (choices) dispatch(setChoices(choices))
    if (title) dispatch(setTitleObj(title))
    dispatch(setDataStatus('Unchanged'))
    if (keyText) dispatch(changeKeyText())
  }

export const setHistory = history => ({
  type: SET_HISTORY,
  payload: {
    history,
  },
})

//input item actions callback
export const itemWheelChanged =
  (newValue, index) => async (dispatch, getState) => {
    const choices = getState().main.choices
    let newChoices = choices.slice(0)
    newChoices[index].name = newValue
    dispatch(setChoices(newChoices, false))
  }

export const itemWeightChanged =
  (weight, index) => async (dispatch, getState) => {
    const choices = getState().main.choices
    let newChoices = choices.slice(0)
    if (weight === 1) {
      delete newChoices[index]['weight']
    } else {
      newChoices[index]['weight'] = weight
    }
    dispatch(setChoices(newChoices, false))
  }

export const itemToggleChanged =
  (status, index) => async (dispatch, getState) => {
    const choices = getState().main.choices
    let newChoices = choices.slice(0)
    newChoices[index].filtered = !status //inverse the value
    dispatch(setChoices(newChoices))
  }

export const itemCloseClicked = id => async (dispatch, getState) => {
  const choices = getState().main.choices
  const choiceHDImages = getState().main.choiceHDImages
  if (choiceHDImages.length > 0) {
    const updatedHDImages = deleteHDImage(choiceHDImages, id)
    dispatch(setChoiceHDImages(updatedHDImages))
  }

  let array = choices.slice(0)
  array.splice(id, 1)
  if (array.length === 0) {
    dispatch(setMode(0))
  }
  dispatch(setChoices(array))
  dispatch(changeKeyText())
}

export const itemDuplicateClicked = index => async (dispatch, getState) => {
  const choices = getState().main.choices
  let array = choices.slice(0)
  const insertIndex = index + 1
  array.splice(insertIndex, 0, { ...choices[index], filtered: false })

  // Update HD images
  const choiceHDImages = getState().main.choiceHDImages
  if (choiceHDImages.length > 0) {
    let updatedHDImages = [...choiceHDImages]
    updatedHDImages = duplicateHDImage(
      choiceHDImages,
      updatedHDImages,
      index,
      insertIndex,
    )
    dispatch(setChoiceHDImages(updatedHDImages))
  }
  dispatch(setChoices(array))
  dispatch(changeKeyText())
}

export const itemImageChanged =
  (data, index, blobData = null) =>
  (dispatch, getState) => {
    const choices = getState().main.choices

    const choiceHDImages = getState().main.choiceHDImages

    let newChoices = choices.slice(0)
    if (data === null) {
      delete newChoices[index]['data']
      // Find and revoke the blob URL before removing
      const removedItem = choiceHDImages.find(item => item.index === index)
      if (removedItem) {
        if (removedItem.imageUrl.startsWith('blob:')) {
          revokeUnusedBlobURL(choiceHDImages, removedItem)
        }
        const updatedHDImages = choiceHDImages.filter(
          item => item.index !== index,
        )
        dispatch(setChoiceHDImages(updatedHDImages))
      }
    } else {
      newChoices[index]['data'] = data
      if (blobData) {
        const newChoiceHDImages = choiceHDImages.slice()
        // add new blob
        newChoiceHDImages.push(blobData)
        dispatch(setChoiceHDImages(newChoiceHDImages))
      }
    }
    dispatch(setChoices(newChoices, false))
  }

//03-07-2021 add title
export const setTitleActive = active => dispatch => {
  dispatch(setTitleObj({ active }))
}

export const setTitleText = text => dispatch => {
  dispatch(setTitleObj({ text }))
}

export const setTitleObj = obj => dispatch => {
  dispatch({
    type: SET_TITLE_OBJ,
    payload: {
      obj,
    },
  })
  dispatch(setDataStatus('Modified', 'Title & Desc.'))
}

export const setWeightOn = status => dispatch => {
  dispatch({
    type: SET_WEIGHT_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setSavedLists = lists => {
  return {
    type: SET_SAVED_LISTS,
    payload: {
      lists,
    },
  }
}

export const resetInitialState = () => {
  return {
    type: RESET_INITIAL_STATE,
  }
}

export const replaceState = data => {
  return {
    type: REPLACE_STATE,
    payload: {
      data,
    },
  }
}

export const itemHeadlineChanged =
  (headline, index) => async (dispatch, getState) => {
    const choices = getState().main.choices
    let newChoices = choices.slice(0)
    if (headline === '') {
      delete newChoices[index]['headline']
    } else {
      newChoices[index]['headline'] = headline
    }
    dispatch(setChoices(newChoices, false))
  }

export const setHeadlineOn = status => dispatch => {
  dispatch({
    type: SET_HEADLINE_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const itemColorChanged =
  (color, index) => async (dispatch, getState) => {
    const choices = getState().main.choices
    let newChoices = choices.slice(0)
    if (color === '') {
      delete newChoices[index]['color']
    } else {
      newChoices[index]['color'] = color
    }
    dispatch(setChoices(newChoices, false))
  }

export const setColorOn = status => dispatch => {
  dispatch({
    type: SET_COLOR_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Inputs'))
}

export const setInputShowMode = showMode => dispatch => {
  dispatch({
    type: SET_INPUT_SHOW_MODE,
    payload: {
      showMode,
    },
  })
}

export const setInputEditMode = mode => ({
  type: SET_INPUT_EDIT_MODE,
  payload: {
    mode,
  },
})

export const setMysteryWheelOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_WHEEL_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const setMysteryResultOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_RESULT_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const updateMysterySettings =
  (mysteryWheelOn, mysteryResultOn) => async (dispatch, getState) => {
    try {
      const state = getState()
      const pastMysteryWheelOn = state.main.mysteryWheelOn
      dispatch({
        type: UPDATE_MYSTERY_SETTINGS,
        payload: {
          mysteryWheelOn,
          mysteryResultOn,
        },
      })
      // redraw wheel
      if (pastMysteryWheelOn !== mysteryWheelOn) {
        dispatch(showTurntable(null))
      }
      dispatch(setDataStatus('Unchanged')) //load from sharewheel and load list
    } catch (error) {
      console.log(error)
    }
  }

export const setScores =
  (scores, dataStatus = 'Modified') =>
  dispatch => {
    dispatch({
      type: SET_SCORES,
      payload: {
        scores,
      },
    })
    dispatch(setDataStatus(dataStatus, 'Scores'))
  }

export const setAutoAddCount = status => ({
  type: SET_AUTO_ADD_COUNT,
  payload: {
    status,
  },
})

export const setChoiceHDImages = choiceHDImages => ({
  type: SET_CHOICE_HD_IMAGES,
  payload: {
    choiceHDImages,
  },
})

export const setAiInputLogin = show => ({
  type: SET_AI_INPUT_LOGIN,
  payload: {
    show,
  },
})

export const setAiInputOpened = status => ({
  type: SET_AI_INPUT_OPENED,
  payload: {
    status,
  },
})

export const setAiInputGroups = groups => ({
  type: SET_AI_INPUT_GROUPS,
  payload: {
    groups,
  },
})
